import { ThemeConfig } from 'antd';

export const themeConfig: ThemeConfig = {
  token: {
    colorPrimary: '#b99258',
    colorInfo: '#547590',
    borderRadius: 16,
    colorBgLayout: '#d8e0e5',
    colorBgContainer: 'rgba(224, 230, 234, 0.86)',
    colorBgElevated: 'rgba(232, 237, 240, 0.96)',
    colorBorder: 'rgba(16, 27, 35, 0.12)',
    colorBorderSecondary: 'rgba(16, 27, 35, 0.08)',
    fontFamily: "'Microsoft YaHei', 'PingFang SC', 'Segoe UI', sans-serif",
    boxShadow: '0 20px 48px rgba(46, 60, 70, 0.14)',
    boxShadowSecondary: '0 12px 28px rgba(46, 60, 70, 0.12)',
    colorTextHeading: '#10171d',
    colorText: '#364954',
    colorTextSecondary: '#667986',
  },
  components: {
    Layout: {
      siderBg: '#c7d1d8',
      headerBg: 'rgba(228, 233, 237, 0.92)',
      bodyBg: '#d8e0e5',
      triggerBg: '#b99258',
    },
    Menu: {
      darkItemBg: 'transparent',
      darkItemSelectedBg: '#b99258',
      darkItemColor: '#41535f',
      darkItemSelectedColor: '#10171d',
      darkSubMenuItemBg: 'rgba(255,255,255,0.18)',
      itemHeight: 42,
      itemMarginInline: 8,
      itemBorderRadius: 12,
    },
    Card: {
      boxShadow: '0 18px 40px rgba(46, 60, 70, 0.12)',
      headerFontSize: 16,
      headerFontWeight: 600,
      colorBorderSecondary: 'rgba(16, 27, 35, 0.08)',
    },
    Table: {
      headerBg: 'rgba(210, 218, 224, 0.9)',
      headerColor: '#41535f',
      headerBorderRadius: 12,
      rowHoverBg: 'rgba(255,255,255,0.45)',
      borderColor: 'rgba(16, 27, 35, 0.08)',
    },
    Button: {
      controlHeight: 38,
      fontWeight: 600,
      borderRadius: 999,
      defaultShadow: '0 8px 18px rgba(46, 60, 70, 0.12)',
      primaryShadow: '0 12px 24px rgba(185, 146, 88, 0.24)',
    },
    Input: {
      controlHeight: 38,
      borderRadius: 12,
      colorBorder: 'rgba(84, 117, 144, 0.18)',
      hoverBorderColor: '#547590',
      activeBorderColor: '#547590',
      activeShadow: '0 0 0 2px rgba(84, 117, 144, 0.12)',
    },
    InputNumber: {
      controlHeight: 38,
      borderRadius: 12,
    },
    Select: {
      controlHeight: 38,
      borderRadius: 12,
      optionSelectedBg: 'rgba(185, 146, 88, 0.16)',
    },
    Modal: {
      contentBg: 'rgba(232, 237, 240, 0.98)',
      headerBg: 'rgba(232, 237, 240, 0.98)',
      titleColor: '#10171d',
      titleFontSize: 18,
      borderRadiusLG: 24,
    },
    Drawer: {
      colorBgElevated: 'rgba(232, 237, 240, 0.98)',
      footerPaddingBlock: 16,
      footerPaddingInline: 20,
    },
    Descriptions: {
      colorFillAlter: 'rgba(210, 218, 224, 0.9)',
      colorTextSecondary: '#667986',
    },
    Collapse: {
      headerBg: 'rgba(220, 227, 232, 0.78)',
      contentBg: 'rgba(232, 237, 240, 0.78)',
      borderRadiusLG: 18,
    },
    Tabs: {
      itemActiveColor: '#10171d',
      itemColor: '#667986',
      itemHoverColor: '#547590',
      inkBarColor: '#b99258',
    },
    Tag: {
      borderRadiusSM: 999,
    },
    Badge: {
      dotSize: 8,
    },
    Dropdown: {
      colorBgElevated: 'rgba(232, 237, 240, 0.98)',
    },
    DatePicker: {
      colorBgContainer: 'rgba(224, 230, 234, 0.86)',
      colorBgElevated: 'rgba(232, 237, 240, 0.98)',
      colorBorder: 'rgba(84, 117, 144, 0.18)',
    },
    TimePicker: {
      colorBgContainer: 'rgba(224, 230, 234, 0.86)',
      colorBgElevated: 'rgba(232, 237, 240, 0.98)',
      colorBorder: 'rgba(84, 117, 144, 0.18)',
    },
    Switch: {
      colorPrimary: '#b99258',
      colorPrimaryHover: '#a07840',
      handleSize: 20,
    },
    Radio: {
      buttonCheckedBg: '#b99258',
      colorPrimary: '#b99258',
    },
    Checkbox: {
      colorPrimary: '#547590',
    },
    Tooltip: {
      colorBgSpotlight: 'rgba(232, 237, 240, 0.98)',
      colorTextLightSolid: '#10171d',
    },
    Popconfirm: {
      colorBgElevated: 'rgba(232, 237, 240, 0.98)',
    },
    Steps: {
      colorPrimary: '#b99258',
      colorTextSecondary: '#667986',
    },
    Tree: {
      directoryNodeSelectedBg: 'rgba(185, 146, 88, 0.12)',
      selectedLineBg: 'rgba(185, 146, 88, 0.08)',
    },
    AutoComplete: {
      colorBgElevated: 'rgba(232, 237, 240, 0.98)',
    },
    Pagination: {
      colorBgContainer: 'rgba(224, 230, 234, 0.86)',
      itemActiveBg: '#b99258',
      itemActiveTextColor: '#ffffff',
      colorPrimary: '#b99258',
      colorText: '#364954',
      itemBorderColor: 'rgba(16, 27, 35, 0.08)',
    },
    Segment: {
      itemSelectedBg: 'rgba(185, 146, 88, 0.16)',
      itemSelectedColor: '#10171d',
    },
  },
};
